import { v4 as uuidv4 } from 'uuid';

// Function to generate a unique token
export const generateToken = (username, userId) => {
    // Generate a UUID token (random, unique per user session)
    const token = uuidv4(); // Generates a random UUID
    return token;
};
